import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PdfViewerAdapterService } from '@shared/pdf-viewer-adapter/services/pdf-viewer-adapter.service';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'mojo-pdf-viewer-adapter',
  templateUrl: './pdf-viewer-adapter.component.html',
  styleUrls: ['./pdf-viewer-adapter.component.scss'],
})
export class PdfViewerAdapterComponent implements OnDestroy {
  @Input() set pdfSrc(value: string) {
    this.pdfSrcValue = value;
    this.preparePdfUrlToDisplayResumeInIframe();
  }

  @Input() pdfId: number;
  @Input() isFullScreenEnable = false;
  @Output() pdfLoaded = new EventEmitter();

  searchForm: FormGroup;
  pdfSrcValue = '';
  pdfUrl = '';
  iframesSrc = [];
  isPdfLoaded = false;

  private subs = new Subscription();

  constructor(
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private pdfViewerAdapterService: PdfViewerAdapterService,
    private fb: FormBuilder,
  ) {
    this.searchForm = this.fb.group({
      query: [null],
      wholeWords: [false],
    });
    this.searchWordsInPdf();
  }

  ngOnDestroy() {
    this.pdfViewerAdapterService.pdfUrl = null;
  }

  ///////////////////////////////////////////////////
  /////HIDE IMPLEMENTATION DETAILS BELOW////////////
  //////////////////////////////////////////////////

  async preparePdfUrlToDisplayResumeInIframe(words?: string[], wholeWords?: boolean) {
    if (this.pdfSrcValue) {
      await this.preparePdfArrayBuffer(words, !!wholeWords);
    }
  }

  searchWordsInPdf() {
    this.searchForm.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((searchFormValues) => {
        this.preparePdfUrlToDisplayResumeInIframe(
          [searchFormValues.query],
          searchFormValues.wholeWords,
        );
      });
  }

  onPdfLoad() {
    this.pdfLoaded.emit();
    this.isPdfLoaded = true;
    setTimeout(() => {
      if (this.iframesSrc.length > 1) {
        this.iframesSrc.pop();
        this.cdRef.detectChanges();
      }
    }, 200);
  }

  private async preparePdfArrayBuffer(words: string[], wholeWords: boolean) {
    const wordsProperty = words ?? [''];
    URL.revokeObjectURL(this.pdfUrl);
    const arrayBuffer = await fetch(this.pdfSrcValue)
      .then((response) => response.arrayBuffer())
      .catch((error) => console.error(error));
    if (arrayBuffer) {
      this.subs.add(
        this.pdfViewerAdapterService
          .highlightWordsFromCandidateFilters(arrayBuffer, this.pdfId, wordsProperty, wholeWords)
          .pipe(
            map(
              (pdfBytesWithHighlights) =>
                new Blob([pdfBytesWithHighlights], { type: 'application/pdf' }),
            ),
            map((blob) => URL.createObjectURL(blob)),
          )
          .subscribe((pdfUrlTemp) => {
            this.pdfUrl = pdfUrlTemp.concat('#navpanes=0');
            if (!this.pdfViewerAdapterService.pdfUrl) {
              this.pdfViewerAdapterService.pdfUrl = this.pdfUrl;
            }
            this.setUrl(pdfUrlTemp.concat('#navpanes=0&view=FitH'));
          }),
      );
    }
  }

  setUrl(url: any) {
    setTimeout(() => {
      this.iframesSrc.unshift(this.bypassAndSanitize(url));
      this.cdRef.detectChanges();
    }, 50);
  }

  bypassAndSanitize(url: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
